<template>
  <div>
    <Form
      ref="item"
      :model="formItem"
      :rules="ruleValidate"
      :label-width="80"
      style="padding: 20px 10px"
    >
      <FormItem label="旧密码" prop="oldPassword">
        <Input
          password
          type="password"
          v-model="formItem.oldPassword"
          placeholder="请输入旧密码"
        ></Input>
      </FormItem>
      <FormItem label="新密码" prop="newPassword">
        <Input
          password
          type="password"
          v-model="formItem.newPassword"
          placeholder="请输入新密码"
        ></Input>
      </FormItem>

      <Button
        type="primary"
        long
        @click="updatePwd('item')"
        style="margin-top: 30px"
        >保存修改</Button
      >
    </Form>
  </div>
</template>
<script>
import axios from "axios";
var oldPassword;
export default {
  data() {
    return {
      buttonStatus: 1, //1-编辑  0--保存
      buttonType: "default",
      formItem: {
        oldPassword: "",
        newPassword: "",
      },
      ruleValidate: {
        oldPassword: { required: true, message: "必填项" },
        newPassword: { required: true, message: "必填项" },
      },
    };
  },
  methods: {
    updatePwd(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.formItem.oldPassword.length < 6) {
            this.$Message.error({
              content: "旧密码不足6位",
              duration: 2,
            });
            return;
          } else if (this.formItem.newPassword.length < 6) {
            this.$Message.error({
              content: "新密码不足6位",
              duration: 2,
            });
            return;
          }
          let params = {
            newPassword: this.formItem.newPassword,
            oldPassword: this.formItem.oldPassword,
          };
          axios({
            method: "post",
            url: "/personal/updatePwd",
            data: params,
          }).then((res) => {
            if (res.data.code != 200) {
              this.$Message.error({
                content: res.data.message,
                duration: 2,
              });
            } else {
              this.$Message.success({
                content: "修改成功，请用新密码登录",
                duration: 5,
              });
              this.$router.push({
                path: "/login",
              });
            }
          });
        }
      });
    },
  },
};
</script>
<style lang="">
</style>


// WEBPACK FOOTER //
// src/components/doc/password.vue